import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import ListTopSearch from "../../Global Functions/listTopSearch";
import { GetVrVisitList } from "../../Redux/Actions/homeVisitActions";
import { columnsVrVisitList } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import toast from "react-hot-toast";

const VrVisitList = () => {
  const dispatch = useDispatch();

  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [searchQuery, setSearchQuery] = useState("");

  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const { vrVisits, vrVisitTotal, loading } = useSelector(
    (state) => state.homeVisit || {}
  );

  const fetchDetails = useCallback(
    async (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        filter: debouncedSearch,
        ...(dateRange.start && {
          start_date: dateRange.start.format("YYYY-MM-DD"),
        }),
        ...(dateRange.end && {
          end_date: dateRange.end.format("YYYY-MM-DD"),
        }),
      };

      try {
        await dispatch(GetVrVisitList(payload));
        if (!showLoader) toast.success("VR visit list refreshed");
      } catch {
        if (showLoader) toast.error("Failed to fetch VR visit list");
      }
    },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [fetchDetails, pagination.current, pagination.pageSize]);

  useEffect(() => {
    if (vrVisitTotal !== undefined) {
      setPagination((prev) => ({ ...prev, total: vrVisitTotal }));
    }
  }, [vrVisitTotal]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  return (
    <>
      <div className="bookings_table">
        <div className="table_component_all">
          <div style={{ gridColumn: "span 5", height: "auto" }}>
            <ListTopSearch
              h3heading="VR Visit List"
              setState={setSearchQuery}
              onCalendarClick={() => setIsDatePopupVisible(true)}
            />
          </div>

          <div className="custom_table">
            <div style={{ padding: "0px 60px" }}>
              <Table
                dataSource={Array.isArray(vrVisits) ? vrVisits : []}
                columns={columnsVrVisitList(pagination.current, pagination.pageSize)}
                pagination={pagination}
                loading={loading}
                onChange={handleTableChange}
                scroll={{ x: 1700, y: 500 }}
                rowClassName={() => "text-center"}
              />
            </div>
          </div>
        </div>
      </div>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default VrVisitList;
